import { ProfileForm } from '@/features/profile/profile-form'
import { UpdatePasswordForm } from '@/features/profile/update-password-form'
import { ProtectedRoute } from '@/components/auth/protected-route'
import { useState } from 'react'
import { useAuth } from '@/context/auth-context'

function AccountPage() {
  const [activeTab, setActiveTab] = useState<'profile' | 'security'>('profile')
  const { user } = useAuth()

  return (
    <ProtectedRoute>
      <div className="min-h-screen bg-background p-4 md:p-8">
        <div className="max-w-7xl mx-auto">
          <h1 className="text-3xl font-bold text-text mb-8">Account</h1>

          <div className="grid grid-cols-1 md:grid-cols-12 gap-8">
            {/* Sidebar navigation */}
            <div className="md:col-span-3">
              <nav className="space-y-1 sticky top-8">
                <button
                  onClick={() => setActiveTab('profile')}
                  className={`flex w-full items-center px-4 py-3 text-text rounded-md border-l-4 transition-colors ${
                    activeTab === 'profile'
                      ? 'bg-primary/10 border-primary'
                      : 'border-transparent hover:bg-gray-800/50'
                  }`}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="h-5 w-5 mr-3"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"
                    />
                  </svg>
                  Profile Information
                </button>
                <button
                  onClick={() => setActiveTab('security')}
                  className={`flex w-full items-center px-4 py-3 text-text rounded-md border-l-4 transition-colors ${
                    activeTab === 'security'
                      ? 'bg-primary/10 border-primary'
                      : 'border-transparent hover:bg-gray-800/50'
                  }`}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="h-5 w-5 mr-3"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z"
                    />
                  </svg>
                  Security
                </button>
              </nav>
            </div>

            {/* Main content */}
            <div className="md:col-span-9">
              {activeTab === 'profile' && (
                <div id="profile" className="animate-fadeIn">
                  <ProfileForm />
                </div>
              )}

              {activeTab === 'security' && (
                <div id="security" className="animate-fadeIn space-y-8">
                  <div className="p-6 bg-card rounded-lg border border-border">
                    <h2 className="text-xl font-bold text-text mb-4">Account Information</h2>
                    <div className="space-y-4">
                      <div>
                        <p className="text-sm text-text/70">Email</p>
                        <p className="text-text">{user?.email}</p>
                      </div>
                      <div>
                        <p className="text-sm text-text/70">Account Created</p>
                        <p className="text-text">
                          {user?.created_at
                            ? new Date(user.created_at).toLocaleDateString()
                            : 'Unknown'}
                        </p>
                      </div>
                      <div>
                        <p className="text-sm text-text/70">Last Sign In</p>
                        <p className="text-text">
                          {user?.last_sign_in_at
                            ? new Date(user.last_sign_in_at).toLocaleDateString()
                            : 'Unknown'}
                        </p>
                      </div>
                    </div>
                  </div>

                  <div className="p-6 bg-card rounded-lg border border-border">
                    <UpdatePasswordForm />
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </ProtectedRoute>
  )
}

export { AccountPage }
